import React from 'react';
import {
  FaFileAlt,
  FaFilePdf,
  FaFileVideo,
  FaFileAudio,
  FaFileArchive,
  FaFileExcel,
  FaFileWord,
  FaFilePowerpoint,
  FaFileCsv
} from 'react-icons/fa';

export const IMAGE_REGEX = /\.(png|jpe?g|gif|webp|svg)$/i;

export const isImageFile = (name = '') => IMAGE_REGEX.test(name);

export const getFileExtensionLabel = (name = '') => {
  const parts = name.split('.');
  return parts.length > 1 ? parts.pop().toUpperCase() : 'FILE';
}

export const getFileIcon = (name = '') => {
  const lower = name.toLowerCase();
  if (lower.endsWith('.pdf')) return <FaFilePdf />;
  if (/\.(mp4|webm|ogg|mov)$/.test(lower)) return <FaFileVideo />;
  if (/\.(mp3|wav)$/.test(lower)) return <FaFileAudio />;
  if (lower.endsWith('.zip')) return <FaFileArchive />;
  if (/\.xlsx?$/.test(lower)) return <FaFileExcel />;
  if (/\.docx?$/.test(lower)) return <FaFileWord />;
  if (/\.pptx?$/.test(lower)) return <FaFilePowerpoint />;
  if (lower.endsWith('.csv')) return <FaFileCsv />;
  return <FaFileAlt />;
}

export const formatBytes = (bytes) => {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1048576) return `${Math.round((bytes / 1024) * 10) / 10} KB`;
  return `${Math.round((bytes / 1048576) * 10) / 10} MB`;
}
